module.exports = __webpack_public_path__ + "img/mfa-logo.b1b7ec30.png";